import React from "react";
import appConstant from "../../../../../appConstants";
import { withStyles, withTheme } from "@material-ui/core";
import styles from "../../styles";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import Map, {
  Marker,
  Popup,
  MapControls,
  MapConstant,
} from "../../../../../lib/Map";
import {
  TerminalMarker,
  AnchorPointMarker,
} from "../../../../../components/mapComponents/Markers";
import {
  AnchorPointPopupInfo,
  ZonePopUpInfo,
} from "../../../../../components/mapComponents/Popups";
import MapAutoZoom from "../../../../../layout/layoutHeader/components/MapAutoZoom";
import Events from "../../../../../utilities/EventEmitter";
import { withAppConfig } from "../../../../../appConfigContext";

class AnchorPointMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAutoZoomEnabled: false,
    };
    this.selectedAnchorPoint =
      this.props.selectedAnchorPoints &&
      this.props.selectedAnchorPoints.length === 1
        ? data.find(
            (anchor) =>
              anchor.anchorPointName === this.props.selectedAnchorPoints[0]
          )
        : null;
  }

  onMarkerDragEnd = (stop) => {
    this.props.anchorPointsPositionChange({
      latitude: stop.position.lat,
      longitude: stop.position.lng,
    });
  };

  toggleRouteAnimation = (value) => {
    this.setState({
      isAutoZoomEnabled: value,
    });
  };

  anchorPointMarkerParams = (anchorPoint) => {
    const isActiveAnchorPoint = this.props.selectedAnchorPoints?.includes(
      anchorPoint.anchorPointName
    );
    const activeAnchorPointColor = isActiveAnchorPoint
      ? appConstant.Colors.markerActiveColor
      : null;
    const markerColor = !anchorPoint.isSelected
      ? appConstant.Colors.disabledColor
      : activeAnchorPointColor;
    const zIndex = isActiveAnchorPoint ? 1 : 0; // used rerender icon when isSelected property is changed on active anchor point
    const markerDimension = isActiveAnchorPoint ? "35px" : "23px";
    return {
      isActiveAnchorPoint: isActiveAnchorPoint,
      markerColor: markerColor,
      zIndex: zIndex,
      markerDimension: markerDimension,
      isAnchorPointSelected: this.props.isAddUpdateAnchorPointFormOpen
        ? isActiveAnchorPoint
        : true,
    };
  };

  ShowEditAnchorPointPosition = (anchorPoint) => {
    if (
      this.props.anchorPointsPosition &&
      this.props.anchorPointsInfo?.anchorPointName ===
        anchorPoint.anchorPointName
    ) {
      return {
        lat: this.props.anchorPointsPosition.latitude,
        lng: this.props.anchorPointsPosition.longitude,
      };
    } else {
      return {
        lat: anchorPoint.latitude,
        lng: anchorPoint.longitude,
      };
    }
  };

  onMapClick = (e) => {
    if (
      this.props.isAddUpdateAnchorPointFormOpen &&
      !this.props.anchorPointsInfo &&
      !this.props.anchorPointsPosition
    ) {
      this.props.anchorPointsPositionChange({
        latitude: e.lat,
        longitude: e.lng,
      });
    }
    this.props.onAnchorPointClicked(null);
  };

  render() {
    const { classes, theme, data, zoneInfo, onZoneClicked, configJSON } =
      this.props;
    const { location: terminalLocation, code: terminalID } =
      this.props.userData.userProfile.terminal;

    return (
      <div className={classes.anchorSubModulePart}>
        <header
          className={`${classes.moduleHeader} ${classes.anchorPointHeader}`}
          data-automationid="anchorPointMap-title"
        >
          Anchor Point Map
          <span className={classes.anchorPointAutoZoom}>
            <MapAutoZoom
              isEnabled={this.state.isAutoZoomEnabled}
              toggleRouteAnimation={this.toggleRouteAnimation}
              userData={this.props.userData}
              isMenuItem={true}
              eventHub={Events}
              title={`${
                this.state.isAutoZoomEnabled ? "Disable" : "Enable"
              } Auto Zoom`}
            ></MapAutoZoom>
          </span>
        </header>
        <div className={classes.anchorPointModuleContainer}>
          <div
            className={
              this.props.isAddUpdateAnchorPointFormOpen &&
              !this.props.anchorPointsInfo &&
              !this.props.anchorPointsPosition
                ? `${classes.anchorPointContent} ${classes.anchorPointMap}`
                : classes.anchorPointContent
            }
          >
            <Map
              zoom={
                this.state.isAutoZoomEnabled &&
                this.props.isAddUpdateAnchorPointFormOpen
                  ? 15
                  : 9
              }
              initialCenter={terminalLocation}
              center={terminalLocation}
              onClick={this.onMapClick}
              mapId={"anchorPointMap"}
              mapTheme={theme.themeName}
              mapConfig={configJSON?.maps}
            >
              <MapControls
                controlOptions={{
                  zoomControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  satelliteViewControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  reCenterMapControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  showZones: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                    terminalID: terminalID,
                    onZoneClicked: onZoneClicked,
                    geoJson: this.props.userData.userProfile?.geoJson,
                  },
                }}
              />
              <Marker
                position={terminalLocation}
                animation
                // anchor point is the point in the image which should overlap the location,
                // Terminal image is of different size than the marker so we can override the default value as shown below
                anchorPoint={{ x: 20, y: 20 }}
                zIndex={1}
                forceUpdate={true}
                isActiveShipment
              >
                <TerminalMarker
                  data={this.props.userData.userProfile.terminal}
                  color={theme.terminalContentColor}
                />
              </Marker>
              {data?.map((anchorPoint) => {
                const params = this.anchorPointMarkerParams(anchorPoint);
                return (
                  <Marker
                    data={anchorPoint}
                    position={this.ShowEditAnchorPointPosition(anchorPoint)}
                    key={anchorPoint.anchorPointName}
                    onClick={this.props.onAnchorPointClicked}
                    draggable={Boolean(
                      params.isActiveAnchorPoint && this.props.anchorPointsInfo
                    )}
                    onDragEnd={this.onMarkerDragEnd}
                    forceUpdate={true}
                    isActiveShipment={
                      params.isActiveAnchorPoint && this.state.isAutoZoomEnabled
                    }
                    zIndex={params.zIndex} // display active shipments on top
                  >
                    <AnchorPointMarker
                      backgroundColor={params.markerColor}
                      dimension={params.markerDimension}
                      strokeWidth={params.isAnchorPointSelected ? 1 : 0}
                      fillOpacity={params.isAnchorPointSelected ? "1" : "0.3"}
                    />
                  </Marker>
                );
              })}
              {this.props.isAddUpdateAnchorPointFormOpen &&
                !this.props.anchorPointsInfo &&
                this.props.anchorPointsPosition && (
                  <Marker
                    data={{}}
                    position={{
                      lat: this.props.anchorPointsPosition.latitude,
                      lng: this.props.anchorPointsPosition.longitude,
                    }}
                    key={"new"}
                    onClick={this.props.onAnchorPointClicked}
                    draggable={true}
                    onDragEnd={this.onMarkerDragEnd}
                    zIndex={1} // display active shipments on top
                    forceUpdate={true}
                    isActiveShipment={this.state.isAutoZoomEnabled}
                  >
                    <AnchorPointMarker
                      backgroundColor={appConstant.Colors.markerActiveColor}
                      dimension={"35px"}
                      strokeWidth={1}
                      fillOpacity={1}
                    />
                  </Marker>
                )}

              {this.selectedAnchorPoint &&
                !this.props.isAddUpdateAnchorPointFormOpen && (
                  <Popup
                    position={{
                      lat: this.selectedAnchorPoint.latitude,
                      lng: this.selectedAnchorPoint.longitude,
                    }}
                    // forceRender will rerender the child component into the infowindow,
                    // set to true when theme changes or data is updated for selected shipment
                  >
                    <AnchorPointPopupInfo
                      data={{
                        consigneeName: this.selectedAnchorPoint.anchorPointName,
                        anchorPointEmptyTime:
                          this.selectedAnchorPoint.emptyTime,
                        routeId: this.selectedAnchorPoint.routeId,
                        routeAssigned: this.selectedAnchorPoint.routeAssigned,
                      }}
                      theme={theme.themeName}
                      isAnchorPointModulePopup
                    />
                  </Popup>
                )}
              {zoneInfo && (
                <Popup isCloseButton position={zoneInfo.position}>
                  <ZonePopUpInfo data={zoneInfo.data} />
                </Popup>
              )}
            </Map>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme(),
  withUserProfile,
  withAppConfig
)(AnchorPointMap);
